import { useEffect, useState } from 'react'
import { getNow, subscribe } from '../lib/clock'

/**
 * Reactive "effective now" — re-renders when the admin clock override changes
 * and every `intervalMs` so countdowns and now-relative UI stay fresh without
 * threading the clock through props.
 */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => getNow())
  useEffect(() => {
    const tick = () => setNow(getNow())
    const id = setInterval(tick, intervalMs)
    const unsub = subscribe(tick)
    return () => {
      clearInterval(id)
      unsub()
    }
  }, [intervalMs])
  return now
}
